var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCondaWhiteChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.75,
    fill: "#0D5CB0",
    stroke: "url(#paint0_linear_2154_5326)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7683 14.533C18.6421 14.3908 18.5125 14.2528 18.3792 14.1191C16.8238 12.5573 14.6693 12.0582 12.7005 12.7359C12.599 12.771 12.5161 12.7916 12.4518 12.7979C12.0962 12.832 11.795 12.7145 11.5483 12.4452C10.7837 11.6105 11.4033 10.1989 12.417 10.2818C12.7976 10.3128 13.1294 10.2357 13.4427 9.99509C13.4996 9.95146 13.5906 9.86319 13.7157 9.73028C14.6785 8.70737 15.817 8.13699 17.1313 8.01914C18.721 7.8766 20.3035 8.53595 21.4396 9.80598C21.6193 10.0067 21.7819 10.2336 21.9397 10.4695C22.7954 11.7484 23.1542 13.379 22.939 14.9685C22.7354 16.4712 22.0195 17.8267 20.9759 18.7697C19.1876 20.3856 16.6725 20.5594 14.7074 19.2586C14.6976 19.2519 14.6654 19.2268 14.6109 19.1834C14.4518 19.0562 14.2539 19.1643 14.2188 19.3643C14.195 19.4999 14.264 19.5872 14.3606 19.669C14.5579 19.8359 14.6855 19.9405 14.7434 19.9827C16.0486 20.9328 17.4716 21.2721 19.0124 21.0007C19.0199 20.9995 19.0229 21.0032 19.0215 21.0119C19.0159 21.045 19.0092 21.0786 19.0013 21.1127C18.7605 22.1565 18.3139 23.0597 17.6614 23.8226C17.6106 23.882 17.5544 23.9343 17.4931 23.9793C15.9804 25.0882 14.0559 25.3178 12.3835 24.5488C11.2281 24.0173 10.3319 23.1371 9.69501 21.9083C8.95968 20.4902 8.8236 18.7721 9.21226 17.2C9.4287 16.3242 9.86703 15.5021 10.4107 14.8439C10.4891 14.7492 10.6077 14.6435 10.7667 14.5267C10.8484 14.4666 11.0176 14.3672 11.2743 14.2286C12.9069 13.3463 14.8104 13.3871 16.3967 14.3858C16.576 14.4988 16.6956 14.5696 16.7555 14.5982C17.1985 14.8101 17.6583 14.8656 18.1351 14.7645C18.3433 14.7202 18.5609 14.631 18.7671 14.5404C18.7677 14.5402 18.7682 14.5397 18.7687 14.5391C18.7691 14.5386 18.7694 14.5379 18.7695 14.5371C18.7696 14.5364 18.7696 14.5356 18.7694 14.5349C18.7691 14.5341 18.7688 14.5335 18.7683 14.533Z",
    fill: "url(#paint1_linear_2154_5326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2154_5326",
    x1: -9.14286,
    y1: 16,
    x2: 19.4286,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193E67",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2154_5326",
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondaWhiteChat);
export default __webpack_public_path__ + "static/media/conda-white-chat.d0d56dbecaeb6cfd392436e70a11db4f.svg";
export { ForwardRef as ReactComponent };